import { gql, useQuery } from '@apollo/client';
import { validateZipCode } from '@arcadiapower/warbler';
import { StyledSelect, StyledSelectProps } from '~/components/dropdowns/select.style';
import { CountyData, QueryCountyDataArgs } from '~/typings/graphql';
import { getStyledSystemProps } from '~/utils/styled-system';

export const FETCH_COUNTIES = gql`
  query Flex_FetchCounties($id: Int!, $zipCode: String!) {
    countyData(id: $id, zipCode: $zipCode) {
      counties
    }
  }
`;

interface Props extends StyledSelectProps {
  onChange: (value: string) => void;
  value?: string;
  zipCode: string;
  userId: number;
  defaultCounties: readonly string[];
}

type Option = { text: string; value: string };
type Flex_FetchCountiesQuery = {
  countyData: CountyData;
};

export const CountySelectComponent = ({
  value,
  zipCode,
  onChange,
  userId: id,
  defaultCounties,
  ...rest
}: Props) => {
  const { data, loading } = useQuery<Flex_FetchCountiesQuery, QueryCountyDataArgs>(FETCH_COUNTIES, {
    skip: !validateZipCode(zipCode),
    variables: { zipCode, id },
  });

  const createOption = (county: string) => {
    const option: Option = {
      /**
       * TODO: Gryphon must type 'counties' as not optional in 'CountyData'.
       * we shouldn't be using non-null assertion operator(!) here
       */
      text: county!,
      value: county!,
    };
    return option;
  };

  const getOptions = () => {
    const counties = data && data.countyData.counties;
    if (counties?.length) {
      return counties?.map(createOption);
    } else {
      return defaultCounties?.map(createOption);
    }
  };

  return (
    <StyledSelect
      {...getStyledSystemProps(rest)}
      disabled={loading}
      id="county-select"
      label="Select your county"
      required
      loading={loading}
      minHeight="auto"
      name="county"
      onChange={(value, _e) => onChange(value)}
      options={getOptions()}
      suggestedOptions={[]}
      value={value ? String(value) : ''}
      placeholder="Please select your county"
    />
  );
};
